import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Normalement ici vous auriez une vérification avec votre backend
    // Ceci est juste un exemple pour démonstration
    if (email === 'admin@fooddelivery.com' && password === 'admin123') {
      // Stocker l'état d'authentification dans localStorage
      localStorage.setItem('adminLoggedIn', 'true');
      // Rediriger vers le tableau de bord
      navigate('/admin/dashboard');
    } else {
      setError('Identifiants incorrects. Veuillez réessayer.');
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <h1>Administration</h1>
        <h2>Connexion</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="login-button">Se connecter</button>
        </form>
        
        <div className="back-to-site">
          <a href="/">Retour au site principal</a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;